module.exports = __webpack_public_path__ + "build/img/hun_s.4520b158.png";